// Initialize all sliders
function initializeSliders() {
    // Product slider
    new Swiper(".pf-product-slide", {
        slidesPerView: 4,
        loop: true,
        navigation: {
            nextEl: ".pf-next",
            prevEl: ".pf-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 25,
            }
        }
    });

    // Shop solution slider
    new Swiper(".pf-shop-solution", {
        slidesPerView: 4,
        loop: true,
        navigation: {
            nextEl: ".pf-next",
            prevEl: ".pf-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 25,
            }
        }
    });

    // Review slider
    new Swiper(".pf-rivew-slider", {
        slidesPerView: 4,
        loop: true,
        navigation: {
            nextEl: ".pf-next",
            prevEl: ".pf-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 25,
            }
        }
    });

    // Feedback slider
    new Swiper(".pf-feedback-slider", {
        slidesPerView: 3,
        loop: true,
        navigation: {
            nextEl: ".pf-next",
            prevEl: ".pf-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 25,
            }
        }
    });

    // Bundle slider
    new Swiper(".pf-bundle-slider", {
        slidesPerView: 2,
        loop: true,
        navigation: {
            nextEl: ".pf-next",
            prevEl: ".pf-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 25,
            }
        }
    });

    // Product details page sliders
    const thumbSwiper = new Swiper(".myProductSwiper", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });

    new Swiper(".myProductSwiper2", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbSwiper,
        },
    });
}

// Initialize FAQ accordion
function initializeFaqAccordion() {
    const accordions = document.querySelectorAll('.pf-accordian-card');
    if (accordions.length > 0) {
        const firstAccordion = accordions[0];
        const firstContent = firstAccordion.querySelector('.pf-sub-acc');
        firstAccordion.classList.add('active');
        firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    }

    document.querySelectorAll('.pf-head').forEach(head => {
        head.addEventListener('click', () => {
            const parentCard = head.parentElement;
            const content = parentCard.querySelector('.pf-sub-acc');

            if (parentCard.classList.contains('active')) {
                content.style.maxHeight = null;
                parentCard.classList.remove('active');
            } else {
                document.querySelectorAll('.pf-accordian-card').forEach(card => {
                    card.classList.remove('active');
                    card.querySelector('.pf-sub-acc').style.maxHeight = null;
                });
                parentCard.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

// Initialize isotope filtering
function initializeIsotope() {
    const $container = $('.pf-text-area').isotope({
        itemSelector: 'p',
        layoutMode: 'fitRows'
    });

    $('.btns ul li').click(function () {
        const filterValue = $(this).attr('data-filter');
        $container.isotope({ filter: '.' + filterValue });

        $('.btns ul li').removeClass('active');
        $(this).addClass('active');

        $('.pf-text-area p').removeClass('active').hide();
        $('.pf-text-area .' + filterValue).addClass('active').show();
    });
}

// Initialize everything
function initializeAll() {
    initializeSliders();
    initializeFaqAccordion();
    initializeIsotope();
}

// DOMContentLoaded and Shopify section load event listeners
document.addEventListener('DOMContentLoaded', initializeAll);
document.addEventListener('shopify:section:load', initializeAll);